import React, { useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { createSelector } from 'reselect'; //memoization
import { LazyLoadRequest } from '../../proto/commonpb/list_grpc_web_pb';
import { ServiceContext } from 'context/ServiceContext';

//memoization -  cached result when the same inputs occur again
const lazyAccountNo = createSelector(
  (listClient, value, selectedCorrespondent) =>
    (async () =>
      await lazyAccountNoPromise(listClient, value, selectedCorrespondent))(),
  (returnValue) => returnValue
);

async function lazyAccountNoPromise(listClient, value, selectedCorrespondent) {
  return new Promise((resolve, reject) => {
    let listAccountReq = new LazyLoadRequest();
    listAccountReq.setLimit(100);
    listAccountReq.setKey(value);

    listClient.lazyLoadAccount(listAccountReq, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        const data = response
          .toObject()
          .accountsList.filter((value) => {
            return value.accountNo || value.accountName ? value : null;
          })
          .map((v) => ({
            accountNo: v.accountNo,
            accountName: v.accountName,
            correspondent: v.correspondent,
          }));

        if (selectedCorrespondent) {
          const filterByCorrespondent = data.filter(function(item) {
            return item.correspondent === selectedCorrespondent;
          });
          resolve(filterByCorrespondent);
        } else {
          resolve(data);
        }
      }
    });
  });
}

export default function SelectAccountNo(props) {
  const { listAccountServiceClient: listClient } = useContext(ServiceContext);
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [inputValue, setInputValue] = React.useState(props.value);

  const setPropsValue = (value) => {
    props.onChange({
      currentTarget: {
        name: props.name,
        value: value,
      },
      target: {
        name: props.name,
        value: value,
      },
    });
  };

  const handleOnBlur = async (value) => {
    if (props.freeSolo) {
      setPropsValue(value);
      return;
    }

    if (options.find((o) => o.accountNo === value)) {
      setPropsValue(value);
      return;
    }

    // if selected value does not exist in options and is not a free solo
    setInputValue('');
    setPropsValue('');
  };

  //set local input value and get options
  const handleInputChange = async (event, value) => {
    if (!event) return;
    if (event.type === 'blur') return;
    if (event.type === 'click' && value) return;

    setInputValue(value);
    setPropsValue(value);
    getOptions(value);
  };

  //get list from backend
  const getOptions = async (value) => {
    const list = await lazyAccountNo(
      listClient,
      value,
      props.selectedCorrespondent
    );

    setOptions(list.filter((acct) => acct.accountNo));
  };

  React.useEffect(() => {
    if (open) {
      getOptions(props.value);
    }
    // eslint-disable-next-line
  }, [open]);

  return (
    <Autocomplete
      key={props.clear}
      disabled={props.disabled}
      freeSolo={props.freeSolo}
      id={props.name}
      onInputChange={handleInputChange}
      onBlur={() => {
        handleOnBlur(inputValue);
      }}
      blurOnSelect={false}
      onChange={(_, v) => {
        const value = v ? v.accountNo : '';
        setPropsValue(value);
        setInputValue(value);
      }}
      getOptionSelected={(option, value) =>
        option.accountNo === value.accountNo
      }
      getOptionLabel={(option) =>
        option.accountNo + ' (' + option.accountName + ')'
      }
      inputValue={inputValue}
      options={options}
      name={props.name}
      autoHighlight={true}
      clearOnEscape={true}
      onClose={() => {
        setOpen(false);
      }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          name={props.name}
          required={props.required}
          disabled={props.disabled}
          label={props.label}
          InputLabelProps={{ shrink: true }}
        />
      )}
    />
  );
}
